module.exports = __webpack_public_path__ + "7b6449a974754e285614dd1cb313f408.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_COLOSSAL_CLASHES_W_2040px_H_872px.jpg
// module id = 392
// module chunks = 0